import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-par-nav',
  templateUrl: './par-nav.component.html',
  styleUrls: ['./par-nav.component.css']
})
export class ParNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/par-nav/par-nav.component.ts